import { gql } from '@apollo/client';

export const READ_UNLOCK_CODE_AVAILABILITY = gql`
  query readUnlockCodeAvailability($input: ReadUnlockCodeAvailabilityInput!) {
    readUnlockCodeAvailability(input: $input) {
      available
    }
  }
`;
